import {
  EquipmentService,
  CreateItEquipmentDto,
  UpdateItEquipmentDto,
} from '@services/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '@state/actions'

interface ItEquipmentQueryParams {
  page?: number
  limit?: number
  search?: string
  type?: string
}

export const findAllItEquipment = createAsyncThunk(
  Actions.IT_EQUIPMENT_FIND_ALL,
  async (params: ItEquipmentQueryParams = {}, { rejectWithValue }) => {
    try {
      return await EquipmentService.findAllItEquipment(params)
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message || 'Failed to fetch IT equipments',
      )
    }
  },
)

export const findOneItEquipment = createAsyncThunk(
  'itEquipment/findOne',
  async (id: number, { rejectWithValue }) => {
    try {
      return await EquipmentService.findOneItEquipment(id)
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message || 'Failed to fetch IT equipment',
      )
    }
  },
)

export const createItEquipment = createAsyncThunk(
  Actions.IT_EQUIPMENT_CREATE,
  async (body: CreateItEquipmentDto, { rejectWithValue }) => {
    try {
      return await EquipmentService.createItEquipment(body)
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message || 'Failed to create IT equipment',
      )
    }
  },
)

export const updateItEquipment = createAsyncThunk(
  Actions.IT_EQUIPMENT_UPDATE,
  async (
    { id, body }: { id: number; body: UpdateItEquipmentDto },
    { rejectWithValue },
  ) => {
    try {
      return await EquipmentService.updateItEquipment(id, body)
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message || 'Failed to update IT equipment',
      )
    }
  },
)

export const deleteItEquipment = createAsyncThunk(
  Actions.IT_EQUIPMENT_DELETE,
  async (id: number, { rejectWithValue }) => {
    try {
      await EquipmentService.removeItEquipment(id)
      return id
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message || 'Failed to delete IT equipment',
      )
    }
  },
)

export const deleteBulkItEquipment = createAsyncThunk(
  'itEquipment/deleteBulk',
  async (ids: number[], { rejectWithValue }) => {
    try {
      await EquipmentService.removeBulkItEquipment(ids)
      return ids
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message || 'Failed to delete IT equipments',
      )
    }
  },
)
